// Externe Bibliotheken
import React from 'react';

// Styles
import './contactModal.scss';
import { Icon } from '@/comp/icon/icon.tsx';

export default function contactModal() {
    return (
        <>
            <p>
                <b>Sie haben es sich anders überlegt?</b>
                <br />
                Kein Problem! Unser Serviceteam hilft Ihnen gern bei der Änderung dieser Leistung.
            </p>
            <div className="contact">
                <div className="phone">
                    <Icon name="mobile" ariaHidden />
                    <a href="tel:+4989998299531">+49 89 9982 99 531</a>
                </div>
                <div className="mail">
                    <Icon name="mail" ariaHidden />
                    <a href="mailto:service@aurumtours.de">service@aurumtours.de</a>
                </div>
            </div>
        </>
    );
}
